// extracted by mini-css-extract-plugin
export var chip = "_qv-2";
export var chipBody = "_qv-8";
export var chipHeader = "_qv-9";
export var chipWithKind = "_qv-7";
export var icon = "_qv-3";
export var kind = "_qv-a";
export var remove = "_qv-5";
export var removeIcon = "_qv-6";
export var row = "_qv-0";
export var rowHistorical = "_qv-1";
export var text = "_qv-4";